// extracted by mini-css-extract-plugin
export default {"Calendar":"xHlB-","Calendar--hasTime":"EGhPh","Calendar--withoutMonthsNavigation":"C-wT0","Calendar--isMobile":"_4bg7w","skeleton-progress":"rhdpJ"};